module.exports = __webpack_public_path__ + "img/project.62db0f04.png";